import {createModel} from '@@/package/utils/ModelUtil';
import Model from '@@/package/mapper/Model';
import {
    LevelAssessmentButtonStatusModel
} from "~~/package/mapper/levelAssessment/model/LevelAssessmentButtonStatusModel";

export class LevelAssessmentModel extends Model {
    constructor(
        public title: string = "",
        public level: string = "",
        public trackLevelTitle: string = "",
        public exposureFlag: boolean = false,
        public completeFlag: boolean = false,
        public btnStatus: LevelAssessmentButtonStatusModel = new LevelAssessmentButtonStatusModel()
    ) {
        super();
    }

    public static create(model: Partial<LevelAssessmentModel>): LevelAssessmentModel {
        return createModel<LevelAssessmentModel>(LevelAssessmentModel, {
            ...model
        });
    }

    public static dataMerging(trackContentInfo: LevelAssessmentModel, trackStatusInfo: LevelAssessmentModel): LevelAssessmentModel {
        trackContentInfo.exposureFlag = trackStatusInfo.exposureFlag;
        trackContentInfo.completeFlag = trackStatusInfo.completeFlag;
        trackContentInfo.btnStatus = trackStatusInfo.btnStatus;
        return trackContentInfo;
    }
}
